import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-5 py-10 md:py-16 prose-invert">
      <div className="text-xs tracking-widest uppercase text-primary">Informativa</div>
      <h1 className="font-display text-3xl md:text-5xl mt-2">Privacy Policy</h1>
      <p className="text-foreground/70 mt-3">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

      <div className="mt-8 space-y-6 text-[15px] leading-7 text-foreground/80">
        <section>
          <h2 className="font-display text-2xl text-foreground mt-6">1. Titolare del trattamento</h2>
          <p>Maurizi S.r.l.s. – parquet, scale, ringhiere, infissi. Contatto: <a className="text-primary" href="mailto:info@maurizisrls.com">info@maurizisrls.com</a>.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-foreground">2. Dati raccolti</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Dati di registrazione: nome, email, telefono, password (memorizzata cifrata).</li>
            <li>Dati di prenotazione: servizio richiesto, data/ora, indirizzo (per il sopralluogo), descrizione dell'intervento.</li>
            <li>In caso di accesso con Google: nome, email e foto profilo forniti da Google.</li>
          </ul>
        </section>
        <section>
          <h2 className="font-display text-2xl text-foreground">3. Finalità</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Gestione delle prenotazioni e delle richieste di intervento.</li>
            <li>Comunicazioni di servizio via email (conferme, approvazioni, reminder).</li>
            <li>Adempimenti di legge (fatturazione, contabilità).</li>
          </ul>
        </section>
        <section>
          <h2 className="font-display text-2xl text-foreground">4. Base giuridica</h2>
          <p>Esecuzione di un contratto (art. 6.1.b GDPR) e obblighi di legge (art. 6.1.c GDPR).</p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-foreground">5. Conservazione</h2>
          <p>I dati sono conservati per il tempo necessario alle finalità sopra indicate e, in ogni caso, non oltre 10 anni per obblighi fiscali.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-foreground">6. Diritti dell'interessato</h2>
          <p>Puoi esercitare in qualunque momento i diritti di accesso, rettifica, cancellazione, portabilità e opposizione scrivendo a <a className="text-primary" href="mailto:info@maurizisrls.com">info@maurizisrls.com</a>.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-foreground">7. Cookie</h2>
          <p>Utilizziamo cookie tecnici e di sessione necessari al funzionamento. Vedi la <Link to="/cookie" className="text-primary underline">Cookie Policy</Link>.</p>
        </section>
      </div>
    </div>
  );
}
